/**
 * Sub-abas da Administração (só as seções que a pessoa pode ver) — Nexora Grid (frontend, US-1901).
 *
 * Criado em: 19/10/2026 · Última modificação: 26/10/2026 · Versão: 1.5.0
 */
import { NavLink } from "react-router-dom";
import type { Usuario } from "../api";
import { NOMES } from "../nomes";
import { pode } from "../permissoes";

export function AbasAdmin({ usuario }: { usuario: Usuario }) {
  const abas = [
    ...(pode.verEstrutura(usuario) ? [{ para: "/admin/empresas", texto: NOMES.empresas }, { para: "/admin/dispositivos", texto: NOMES.dispositivos },
      { para: "/admin/conectores", texto: NOMES.conectores }] : []),
    ...(pode.verUsuarios(usuario) ? [{ para: "/admin/usuarios", texto: NOMES.usuarios }, { para: "/admin/canais", texto: NOMES.canais }] : []),
    ...(pode.editarFeriados(usuario) || pode.importarFeriadosNacionais(usuario) ? [{ para: "/admin/feriados", texto: NOMES.feriados }] : []),
    ...(pode.importarReferencias(usuario) || pode.verEstrutura(usuario) ? [{ para: "/admin/referencias", texto: NOMES.referencias }] : []),
    ...(pode.verMarca(usuario) ? [{ para: "/admin/marca", texto: NOMES.marca }] : []),  // US-4503
  ];
  if (abas.length < 2) return null;
  return (
    <nav className="sub-abas abas-admin" aria-label={NOMES.administracao}>
      {abas.map((a) => <NavLink key={a.para} to={a.para} end className={({ isActive }) => (isActive ? "ativa" : "")}>{a.texto}</NavLink>)}
    </nav>
  );
}
